import {
    type NodeEntry,
    type SlateEditor,
} from '@udecode/plate';

import { BaseFootnotesPlugin } from '../BaseFootnotesPlugin';
import type { TFootnoteElement } from '../types';

export const getAllFootnotes = (
    editor: SlateEditor,
): NodeEntry<TFootnoteElement>[] => {
    const type = editor.getType(BaseFootnotesPlugin);

    const nodes = editor.api.nodes<TFootnoteElement>({
        match: n => n.type === type && n.text === undefined,
        at: editor
    });

    return Array.from(nodes);
};
